// Mock data for CarMaintenance website

export const heroData = {
  title: "Votre Véhicule",
  titleHighlight: "Notre Engagement !",
  description: "L'abonnement qui inclut tous les frais de réparations, d'entretien et de maintenance de votre véhicule, pour une expérience simple et sans surprises.",
  ctaText: "Découvrez nos abonnements",
  features: ["Maintenances", "Entretiens", "Réparations"]
};

export const advantagesData = [
  {
    id: 1,
    title: "Abonnement tout inclus",
    description: "Entretenez votre véhicule sans stress. Une formule transparente qui prend en charge chaque intervention, d'un simple entretien à la grosse panne",
    icon: "clipboard"
  },
  {
    id: 2,
    title: "Budget maîtrisé",
    description: "Contrôlez vos dépenses auto avec une formule personnalisée et transparente. Votre véhicule est protégé, votre budget aussi",
    icon: "hand-coins"
  },
  {
    id: 3,
    title: "Votre confiance, notre moteur",
    description: "Pas de frais cachés, pas de mauvaises surprises. Seulement un service clair, honnête, fiable et humain pensé pour vous.",
    icon: "handshake"
  }
];

export const aboutSection = {
  title: "CarMaintenance devient concret",
  description: "Ce que nous avons imaginé devient réel. Le premier garage CarMaintenance a ouvert en septembre à Genève, porté par la force de vos abonnements. Notre vision avance, et chaque nouveau garage sera un pas de plus vers un service automobile repensé rien que pour vous.",
  ctaText: "Découvrez notre vision"
};

export const pricingPlans = [
  {
    id: "s",
    name: "Abonnement S",
    price: 29,
    currency: "CHF",
    period: "mois",
    features: [
      { text: "Service selon plan constructeur", included: true },
      { text: "Réparations couvertes :", included: true, isHeader: true },
      { text: "Moteur", included: true, indent: true },
      { text: "Boîte à vitesses", included: true, indent: true },
      { text: "Boîte de transfert", included: true, indent: true }
    ],
    ctaText: "Estimer mon abonnement",
    popular: false
  },
  {
    id: "m",
    name: "Abonnement M",
    price: 49,
    currency: "CHF",
    period: "mois",
    features: [
      { text: "Couverture de l'abonnement S", included: true },
      { text: "Réparations couvertes additionnelles :", included: true, isHeader: true },
      { text: "Transmission", included: true, indent: true },
      { text: "Direction", included: true, indent: true },
      { text: "Système de freinage", included: true, indent: true },
      { text: "Système de régulation dynamique", included: true, indent: true },
      { text: "Système d'alimentation en carburant", included: true, indent: true },
      { text: "Système de suralimentation", included: true, indent: true },
      { text: "Système de refroidissement", included: true, indent: true },
      { text: "Système d'échappement", included: true, indent: true },
      { text: "Propulsion hybride", included: true, indent: true },
      { text: "Propulsion électrique", included: true, indent: true }
    ],
    ctaText: "Estimer mon abonnement",
    popular: false
  },
  {
    id: "l",
    name: "Abonnement L",
    price: 79,
    currency: "CHF",
    period: "mois",
    features: [
      { text: "Couvertures abonnement S et M", included: true },
      { text: "Réparations couvertes additionnelles :", included: true, isHeader: true },
      { text: "Installation électrique", included: true, indent: true },
      { text: "Protection des occupants", included: true, indent: true },
      { text: "Électronique de confort", included: true, indent: true },
      { text: "Pièces d'usure prises en charge :", included: true, isHeader: true },
      { text: "Freins", included: true, indent: true },
      { text: "Embrayage de boîte à vitesses", included: true, indent: true },
      { text: "Suspension", included: true, indent: true },
      { text: "Direction", included: true, indent: true },
      { text: "Transmission", included: true, indent: true }
    ],
    ctaText: "Estimer mon abonnement",
    popular: true
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Brendan Buck",
    vehicle: "Toyota Prius, depuis 2018",
    testimonial: "Merci pour cette idée superbe ! Enfin un service qui fonctionne, et qui me permet de ne plus me soucier de rien",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop"
  },
  {
    id: 2,
    name: "Stefan Ball",
    vehicle: "Porsche Cayenne, depuis 2021",
    testimonial: "Merci pour cette idée superbe ! Enfin un service qui fonctionne, et qui me permet de ne plus me soucier de rien",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop"
  },
  {
    id: 3,
    name: "Paige Lowery",
    vehicle: "Tesla Model 3, depuis 2020",
    testimonial: "Merci pour cette idée superbe ! Enfin un service qui fonctionne, et qui me permet de ne plus me soucier de rien",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop"
  },
  {
    id: 4,
    name: "Marie Dubois",
    vehicle: "Audi A4, depuis 2019",
    testimonial: "Service impeccable et équipe très professionnelle. Je recommande vivement !",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop"
  },
  {
    id: 5,
    name: "Jean Martin",
    vehicle: "BMW X5, depuis 2020",
    testimonial: "Transparence totale et pas de surprises. Exactement ce que je cherchais.",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop"
  }
];

export const partnersData = [
  { id: 1, name: "Partner 1", logo: "https://via.placeholder.com/150x60/52a675/ffffff?text=Partner+1" },
  { id: 2, name: "Partner 2", logo: "https://via.placeholder.com/150x60/52a675/ffffff?text=Partner+2" },
  { id: 3, name: "Partner 3", logo: "https://via.placeholder.com/150x60/52a675/ffffff?text=Partner+3" },
  { id: 4, name: "Partner 4", logo: "https://via.placeholder.com/150x60/52a675/ffffff?text=Partner+4" },
  { id: 5, name: "Partner 5", logo: "https://via.placeholder.com/150x60/52a675/ffffff?text=Partner+5" },
  { id: 6, name: "Partner 6", logo: "https://via.placeholder.com/150x60/52a675/ffffff?text=Partner+6" }
];

export const faqData = [
  {
    id: "faq-1",
    question: "Qu'est-ce que CarMaintenance ?",
    answer: "CarMaintenance est une société qui propose un service d'abonnement innovant destiné aux particuliers et entreprises propriétaires de véhicules. Il permet de couvrir les frais fixes d'entretien (vidanges, révisions, contrôles) ainsi que de protéger contre les imprévus mécaniques (pannes, réparations importantes), le tout à travers une offre mensuelle simple, transparente et adaptée au profil de chaque véhicule."
  },
  {
    id: "faq-2",
    question: "Comment s'abonner à CarMaintenance ?",
    answer: "Pour vous abonner à CarMaintenance, il vous suffit d'aller sur la page 'Nos Abonnements', de sélectionner la couverture qui vous convient. Vous serez redirigé vers un formulaire intuitif afin de renseigner vos données, celles de votre véhicule ainsi que vos données de paiement. Vous recevrez ensuite une confirmation par mail du contrat d'abonnement."
  },
  {
    id: "faq-3",
    question: "Est-ce que CarMaintenance remplace mon assurance automobile ?",
    answer: "Non. CarMaintenance ne remplace pas votre assurance automobile, mais elle couvre tous les frais liés à l'entretien et à la réparation de votre véhicule."
  },
  {
    id: "faq-4",
    question: "Puis-je choisir ma franchise ?",
    answer: "Oui, vous choisissez la franchise qui vous convient lors de la souscription à votre abonnement."
  },
  {
    id: "faq-5",
    question: "En quoi CarMaintenance est différent d'un garage classique ?",
    answer: "Avec CarMaintenance, vous prenez le contrôle des coûts liés à votre véhicule. Vous payez un montant fixe chaque mois, qui couvre l'entretien, les diverses réparations ainsi que les pièces d'usure. Contrairement à un garage classique, vous savez d'avance ce que vous payez et pour quoi. Plus de doute, plus de stress, juste un service clair et fiable."
  }
];

export const ctaSectionData = {
  title: "Prêt à rouler l'esprit tranquille ?",
  subtitle: "Estimez votre abonnement en 30 secondes, sans engagement.",
  ctaText: "Estimer mon abonnement"
};

export const navigationLinks = [
  { name: "Abonnements", href: "/abonnements" },
  { name: "Nos garages", href: "/nos-partenaires" },
  { name: "FAQ", href: "/faq" },
  { name: "Le projet", href: "/a-propos-de-nous" },
  { name: "Contact", href: "/contact" }
];
